<ng-scrollbar
  style="width: 100%;"
  [style.height]="heightPx ? heightPx+'px' : '700px'">
  <div *ngIf="getSettings()?.length > 0">
    <table class="table">
      <thead>
      <tr>
        <th class="sticky-col first-col tableBg">{{ 'lang.globals.name' | translate }}</th>
        <th>{{ 'lang.globals.value' | translate }}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let setting of sort(getSettings()); index as i; last as last">
        <td class="sticky-col first-col tableBg">{{ setting.name }}</td>
        <td>
          @let strValue = valtoString(setting.value);
          @if (strValue === 'JA') {
            <sb-icon icon="success" class="green"></sb-icon>
          } @else if (strValue === 'NEIN') {
            <sb-icon icon="error" class="red"></sb-icon>
          } @else if (strValue === 'n. def.') {
            <i>&#91;{{ strValue }}&#093;</i>
          } @else {
            {{ strValue }}
          }
        </td>
        <td class="sticky-col last-col tr tableBg">
          <sb-button *ngIf="setting?.datatype?.adPlacerAbleToSet" [disabled]="!editAllowed"
                     (submitClicked)="settingsModal(setting)" classes="btn-primary btn-sm actionbutton">
            <sb-icon icon="edit"></sb-icon>
          </sb-button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-scrollbar>
